import React, { Component } from "react";
import Template from "../template";
import { VstButton } from "vstui";
import { Isvg } from "../../../../components";
import PropTypes from "prop-types";
import EditCardButtons from "./EditCardButtons.jsx";
import CardContent from "./card-content";
import { cardPropTypes } from "../../types";
import { TYPE_IMAGE } from "../../../../../../stores/overleaf-store";
import { getUid } from "../../../../../../utils/uid";

const BASE_HEIGHT = 155;

function getFlipLabelNameFromImageMetadata(meta) {
  if (meta.alt) {
    return meta.alt;
  }
  const title = meta.title || "";
  const caption = meta.caption || "";
  return `${title} ${caption}`;
}

class CardPresentation extends Component {
  state = {
    backHeight: BASE_HEIGHT
  };

  frontId = getUid("CardPresentation");
  backId = getUid("CardPresentation");

  onBackHeightChange = h => {
    this.setState({
      backHeight: h || BASE_HEIGHT
    });
  };

  target = () => {
    let touchDevice = "none";
    if (Fraction.Helpers.Browser.isNewTouchDevice()) {
      touchDevice = "block";
    }
    return (
      <VstButton
        id="mobile-edit-button"
        className="noButton"
        title={i18n.t("reader.flashcards.edit")}
        style={{ display: touchDevice }}
      >
        <Isvg src="/img/ellipsis.svg" />
        <span className="offScreen">{i18n.t("reader.flashcards.edit")}</span>
      </VstButton>
    );
  };

  getFlipButtonLabel() {
    const msg = this.props.flipped
      ? "reader.flashcards.back-flip-card"
      : "reader.flashcards.front-flip-card";
    const cardInfo = this.props.card.front;
    const name =
      cardInfo.type === TYPE_IMAGE
        ? getFlipLabelNameFromImageMetadata(cardInfo.metadata)
        : cardInfo.content;
    return i18n.t(msg, { name });
  }

  render() {
    let {
      cancel,
      card,
      destroy,
      edit,
      editing,
      flip,
      flipped,
      onKeyDown,
      isbn
    } = this.props;
    if (editing) {
      return (
        <Template
          back={card.back}
          editBack={flipped}
          cancel={cancel}
          front={card.front}
          cardUUID={card.uuid}
          deckUUID={card.deckUUID}
          isbn={isbn}
        />
      );
    }

    let confidence = "medium";
    if (card.confidence < 0) {
      confidence = "low";
    } else if (card.confidence > 0) {
      confidence = "high";
    }

    return (
      <li
        className={`card-created no-button`}
        id={"card-created-" + card.uuid}
        style={{ height: flipped ? this.state.backHeight : BASE_HEIGHT }}
      >
        <div
          className={`card-created-inner ${
            flipped ? "flipped" : ""
          } ${confidence}`}
        >
          <EditCardButtons
            show={!flipped}
            edit={edit}
            destroy={destroy}
            target={this.target}
          />
          <div
            aria-label={this.getFlipButtonLabel()}
            role="button"
            tabIndex={0}
            className="noButton card-flip"
            onKeyDown={onKeyDown}
            onClick={flip}
            aria-describedby={flipped ? this.backId : this.frontId}
          >
            <div aria-hidden={flipped} className="front" id={this.frontId}>
              <CardContent cardContent={card.front} shortText />
            </div>
            <div aria-hidden={!flipped} className="back" id={this.backId}>
              <div className="back-inner">
                <CardContent
                  cardContent={card.back}
                  onHeightChange={this.onBackHeightChange}
                />
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

CardPresentation.defaultProps = {
  editing: false,
  flipped: false
};

CardPresentation.propTypes = {
  cancel: PropTypes.func.isRequired,
  card: cardPropTypes,
  destroy: PropTypes.func.isRequired,
  edit: PropTypes.func.isRequired,
  flip: PropTypes.func.isRequired,
  isbn: PropTypes.string.isRequired
};

export default CardPresentation;
